import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "chat-view min-h-screen bg-gray-900 text-white" }
const _hoisted_2 = { class: "container mx-auto py-6 px-4" }
const _hoisted_3 = {
  key: 0,
  class: "bg-red-800 p-4 rounded-lg mb-6"
}
const _hoisted_4 = {
  key: 1,
  class: "flex justify-center items-center h-96"
}
const _hoisted_5 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-3 gap-6 min-h-[700px]"
}
const _hoisted_6 = {
  key: 0,
  class: "md:col-span-1 h-[700px]"
}
const _hoisted_7 = {
  key: 1,
  class: "md:col-span-2 h-[700px] bg-gray-800 rounded-lg overflow-hidden"
}
const _hoisted_8 = {
  key: 1,
  class: "h-full flex items-center justify-center text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_conversation_list = _resolveComponent("conversation-list")!
  const _component_message_list = _resolveComponent("message-list")!
  const _component_toast_notification = _resolveComponent("toast-notification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-2xl font-bold mb-6" }, "Poruke", -1)),
      (_ctx.authError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("p", { class: "text-white" }, [
              _createTextVNode(" Problem sa autentifikacijom. Molimo "),
              _createElementVNode("a", {
                href: "/login",
                class: "underline"
              }, "prijavite se"),
              _createTextVNode(" ponovo. ")
            ], -1)
          ])))
        : (_ctx.showMainLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("svg", {
                  class: "animate-spin h-10 w-10 mx-auto mb-4",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ]),
                _createElementVNode("p", null, "Učitavanje...")
              ], -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!_ctx.isMobile || !_ctx.activeConversation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_conversation_list, { onSelectConversation: _ctx.selectConversation }, null, 8, ["onSelectConversation"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isMobile || _ctx.activeConversation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.activeConversation)
                      ? (_openBlock(), _createBlock(_component_message_list, {
                          key: 0,
                          "show-back-button": _ctx.isMobile,
                          onBack: _ctx.clearActiveConversation,
                          onError: _ctx.handleMessageError,
                          onNotify: _ctx.handleNotification
                        }, null, 8, ["show-back-button", "onBack", "onError", "onNotify"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                          _createElementVNode("div", { class: "text-center p-6" }, [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "h-16 w-16 mx-auto mb-4",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                              })
                            ]),
                            _createElementVNode("p", { class: "text-lg" }, " Izaberite konverzaciju da započnete razgovor ")
                          ], -1)
                        ])))
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _createVNode(_component_toast_notification, {
      show: _ctx.toast.show,
      type: _ctx.toast.type,
      message: _ctx.toast.message,
      title: _ctx.toast.title,
      duration: _ctx.toast.duration,
      onClose: _ctx.closeToast
    }, null, 8, ["show", "type", "message", "title", "duration", "onClose"])
  ]))
}